import { render, staticRenderFns } from "./SearchFilterChip.vue?vue&type=template&id=fa9a85d4&scoped=true"
import script from "./SearchFilterChip.vue?vue&type=script&lang=js"
export * from "./SearchFilterChip.vue?vue&type=script&lang=js"
import style0 from "./SearchFilterChip.vue?vue&type=style&index=0&id=fa9a85d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa9a85d4",
  null
  
)

export default component.exports